module.exports = __webpack_public_path__ + "resources/img/intro-1.d3e52b69.png";